import { useCallback, useEffect, useState } from "react";

const useDetectScrolledToBottom = (node) => {
  const [isBottom, setIsBottom] = useState(false);
  const handleScroll = useCallback(() => {
    const { scrollTop, scrollHeight, clientHeight } = node?.current;
    if (scrollTop + clientHeight >= scrollHeight - 120) {
      setIsBottom(true);
    } else {
      setIsBottom(false);
    }
  }, [node]);
  useEffect(() => {
    if (node.current) {
      node.current.addEventListener("scroll", handleScroll);
      return () => node?.current?.removeEventListener("scroll", handleScroll);
    }
  }, [node, handleScroll]);
  return { isBottom };
};

export default useDetectScrolledToBottom;
